"use client";

import EmptyState from "@/components/portfolio/empty-state";
import { get } from "@/utils/utils";
import { OrderPositionCard, type PositionItemLike } from "./OrderPositionCard";

/**
 * 持仓项数据结构
 */
interface PositionItem {
    key: string;
    label: string;
    guessNo: string;
    guessType: number;
    guessTitle: string;
    guessImageUrl: string;
    shares: number;
    price: number;
    currentPrice: number;
    profit: number;
    profitRate: number;
    initialCost: number;
    payout: number;
    badgeClass: string;
    returnClass: string;
}

interface PositionsTabProps {
    positionItems: PositionItem[];
    event: any;
    guessNo: string;
    eventNo?: string;
    onOpenCashOut: ( item: PositionItem ) => void;
    currentGuess?: any;
}

export function PositionsTab(
    { positionItems, event, guessNo, eventNo: eventNoProp, onOpenCashOut, currentGuess }: PositionsTabProps,
) {
    const eventNo = eventNoProp ?? get( event, "eventNo", "" );

    return (
        <>
            {positionItems.length === 0 && (
                <EmptyState text="No positions found" className="h-auto py-4" textClassName="text-[13px]" />
            )}
            {positionItems.length > 0 && (
                <div className="flex flex-col gap-2 pt-3">
                    {positionItems.slice( 0, 2 ).map( ( item ) => (
                        <OrderPositionCard
                            key={item.key}
                            type="position"
                            item={item as PositionItemLike}
                            currentGuess={currentGuess}
                            guessNo={guessNo}
                            eventNo={eventNo}
                            onSell={( i ) => onOpenCashOut( i as PositionItem )}
                            isSports={false}
                        />
                    ) )}
                </div>
            )}
        </>
    );
}
